import { render, staticRenderFns } from "./import-patient.vue?vue&type=template&id=28cf451c&"
import script from "./import-patient.vue?vue&type=script&lang=ts&"
export * from "./import-patient.vue?vue&type=script&lang=ts&"
import style0 from "./import-patient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports